/**
 * ISO com fuso -> valor de `<input type="datetime-local">` (YYYY-MM-DDTHH:mm)
 * no fuso LOCAL do navegador.
 *
 * `toISOString()` devolveria UTC: a visita das 14h em São Paulo apareceria
 * como 17h no campo (ADR-0059). Vazio/inválido -> "".
 */
export function paraDatetimeLocal(iso) {
  if (!iso) return "";
  const data = new Date(iso);
  if (Number.isNaN(data.getTime())) return "";
  const dois = (n) => String(n).padStart(2, "0");
  return (
    `${data.getFullYear()}-${dois(data.getMonth() + 1)}-${dois(data.getDate())}`
    + `T${dois(data.getHours())}:${dois(data.getMinutes())}`
  );
}
